import React from 'react';
import './DashboardLoader.css';

export default function DashboardLoader({ text = 'Loading...' }) {
  return (
    <div className="dash-loader">
      <div className="dash-loader__content">
        <div className="dash-loader__icon">
          <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="dash-loader__svg">
            <path
              d="M10 50 Q20 25 40 30 Q60 35 50 20 Q65 15 70 30 Q80 45 65 50 Q55 55 45 50 Q35 55 25 50 Q15 55 10 50Z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              className="dash-loader__cloud"
            />
            <line x1="20" y1="60" x2="20" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="dash-loader__wave dash-loader__wave--1" />
            <line x1="35" y1="60" x2="35" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="dash-loader__wave dash-loader__wave--2" />
            <line x1="50" y1="60" x2="50" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="dash-loader__wave dash-loader__wave--3" />
            <line x1="65" y1="60" x2="65" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="dash-loader__wave dash-loader__wave--4" />
          </svg>
        </div>
        <div className="dash-loader__progress">
          <div className="dash-loader__progress-track">
            <div className="dash-loader__progress-fill" />
          </div>
        </div>
        <p className="dash-loader__text">{text}</p>
      </div>
    </div>
  );
}
